import {Check} from '@material-ui/icons';
import React from 'react';

export function CheckIcon() {
  return <Check fontSize="small" color="primary" />;
}
